module.exports = __webpack_public_path__ + "img/default.587488de.webp";